import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CreateDashboardPinRequest, DashboardPin } from '../models/dashboard-pin.model';

@Injectable({ providedIn: 'root' })
export class DashboardPinService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/users/me/dashboard-pins`;

  list(): Observable<DashboardPin[]> {
    return this.http.get<DashboardPin[]>(this.base);
  }

  create(request: CreateDashboardPinRequest): Observable<DashboardPin> {
    return this.http.post<DashboardPin>(this.base, request);
  }

  remove(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${encodeURIComponent(id)}`);
  }
}
